import { useSelector } from 'react-redux';
import { userRoleAboveRequiredLevel } from 'commons/src/features/authorization/userRoleAboveRequiredLevel';
import { RequiredRoleLevel } from 'commons/src/models/commonEnums';
import { Store } from 'commons/src/reducers';

const useHasRequiredRole = (requiredRoleLevel: RequiredRoleLevel): boolean => {
    const { selectedGroup } = useSelector((state: Store) => state.userSettings);
    const userRole = selectedGroup?.role;
    return !userRole || userRoleAboveRequiredLevel(userRole, requiredRoleLevel);
};

export default useHasRequiredRole;
